import {Injectable} from '@angular/core';
import {PartnerModel} from '../model/partner.model';
import {PartnerRepository} from '../../impl/service/ngrx/partner.repository';
import {PartnerDataServiceAdapter} from '../../impl/service/ngrx/partnerDataService.adapter';
import {AbstractFindOneByIdService} from '../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {PartnerSummaryModel} from "../model/partnerSummary.model";
import {PartnerSummaryDataServiceAdapter} from "../../impl/service/ngrx/partnerSummaryDataService.adapter";

@Injectable()
export class PartnerSummaryFindOneByIdService extends AbstractFindOneByIdService<PartnerModel, PartnerSummaryModel>{
    constructor(repository: PartnerRepository, dataServiceAdapter: PartnerSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
